module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-channel-dialog"
  }, [_c('el-dialog', {
    attrs: {
      "visible": _vm.visible,
      "title": "订单属性要求设置",
      "close-on-click-modal": false,
      "modal": false,
      "width": "70%"
    },
    on: {
      "close": _vm.handleCancel
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.localList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "订单属性",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否校验",
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-checkbox', {
          model: {
            value: (row.verification),
            callback: function($$v) {
              _vm.$set(row, "verification", $$v)
            },
            expression: "row.verification"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "包含订单属性值",
      "align": "center",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.code === 'leaveOrder' || row.code === 'repeatOrder') ? _c('div', [_c('el-radio-group', {
          attrs: {
            "size": "small"
          },
          model: {
            value: (row.value),
            callback: function($$v) {
              _vm.$set(row, "value", $$v)
            },
            expression: "row.value"
          }
        }, [_c('el-radio', {
          attrs: {
            "label": 1
          }
        }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": 0
          }
        }, [_vm._v("否")])], 1)], 1) : (row.code === 'customerExpectDeliveryTime') ? _c('div', [_c('el-select', {
          staticClass: "w-full",
          attrs: {
            "filterable": ""
          },
          model: {
            value: (row.value),
            callback: function($$v) {
              _vm.$set(row, "value", $$v)
            },
            expression: "row.value"
          }
        }, _vm._l((_vm.allOptions.customerExpectDeliveryTime), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1) : (row.code === 'brandCategory') ? _c('div', [_c('el-cascader', {
          staticClass: "w-full",
          attrs: {
            "value": _vm.getBrandCategoryCascaderValue(row.value),
            "options": _vm.allOptions.brandCategoryProps,
            "props": {
              multiple: true,
            },
            "collapse-tags": true
          },
          on: {
            "change": function (val) { return _vm.handleBrandCategoryChange(val, row); }
          }
        })], 1) : (row.code === 'physicalShopId') ? _c('div', [_c('el-select', {
          staticClass: "w-full",
          attrs: {
            "multiple": "",
            "filterable": "",
            "collapse-tags": ""
          },
          model: {
            value: (row.value),
            callback: function($$v) {
              _vm.$set(row, "value", $$v)
            },
            expression: "row.value"
          }
        }, _vm._l((_vm.allOptions.physicalShopList), function(item) {
          return _c('el-option', {
            key: item.shopId,
            attrs: {
              "label": item.shopName,
              "value": item.shopId
            }
          })
        }), 1)], 1) : (row.code === 'productChannel') ? _c('div', {
          attrs: {
            "collapse-tags": ""
          }
        }, [_c('div', {
          staticClass: "product-channel-setting-row"
        }, [_c('span', {
          staticClass: "product-channel-label-ellipsis"
        }, [_vm._v("\n                " + _vm._s(_vm.productChannelLabel) + "\n              ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "text",
            "disabled": _vm.getIsDisabled()
          },
          on: {
            "click": function($event) {
              _vm.productChannelDialogVisible = true
            }
          }
        }, [_vm._v("设置")])], 1)]) : (row.code === 'orderType') ? _c('div', [_c('el-select', {
          staticClass: "w-full",
          attrs: {
            "multiple": "",
            "filterable": "",
            "collapse-tags": ""
          },
          model: {
            value: (row.value),
            callback: function($$v) {
              _vm.$set(row, "value", $$v)
            },
            expression: "row.value"
          }
        }, _vm._l((_vm.allOptions.orderType), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1) : (row.code === 'productType') ? _c('div', [_c('el-select', {
          staticClass: "w-full",
          attrs: {
            "multiple": "",
            "filterable": "",
            "collapse-tags": "",
            "disabled": _vm.getIsDisabled()
          },
          model: {
            value: (row.value),
            callback: function($$v) {
              _vm.$set(row, "value", $$v)
            },
            expression: "row.value"
          }
        }, _vm._l((_vm.filterProductCategoryOptions), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": _vm.getProductCategoryLabel(item),
              "value": item.value
            }
          })
        }), 1)], 1) : (row.code === 'designSource') ? _c('div', [_c('el-select', {
          staticClass: "w-full",
          attrs: {
            "multiple": "",
            "filterable": "",
            "collapse-tags": ""
          },
          model: {
            value: (row.value),
            callback: function($$v) {
              _vm.$set(row, "value", $$v)
            },
            expression: "row.value"
          }
        }, _vm._l((_vm.allOptions.orderDesignSource), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1) : _c('div', [_c('span', [_vm._v("未能匹配组件")])])]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), (_vm.productChannelDialogVisible) ? _c('ProductChannelDialog', {
    attrs: {
      "visible": _vm.productChannelDialogVisible,
      "value": _vm.getOrderConditionByCode('productChannel', _vm.localList) ?
        _vm.getOrderConditionByCode('productChannel', _vm.localList).value :
        [],
      "brandCategoryValue": _vm.getOrderConditionByCode('brandCategory', _vm.localList) ?
        _vm.getOrderConditionByCode('brandCategory', _vm.localList).value :
        []
    },
    on: {
      "update:visible": function($event) {
        _vm.productChannelDialogVisible = $event
      },
      "confirm": _vm.handleProductChannelConfirm
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3eb3fc86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/developerInfo/components/OrderConditionDialog.vue
// module id = 2415
// module chunks = 68